function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
import * as React from 'react';
import PropTypes from 'prop-types';
import { color, css, spacing, StyleSheet } from "../../../styles/theme";
import { compose, getContext, setDisplayName } from 'recompose';
export var CARD_SECTION_TYPE = {
  BLOCK: 'block',
  HEADER: 'header',
  FOOTER: 'footer',
  IMAGE: 'image'
};
var CONFIG = {
  border: "1px solid ".concat(color.divider),
  headerFooter: {
    background: color.bgGray,
    backgroundThemeDark: color.bgGrayThemeDark
  },
  paddingHorizontal: spacing.lg,
  paddingVertical: spacing.sm
};
var styles = StyleSheet.create({
  cardBlock: {
    padding: "".concat(CONFIG.paddingVertical, " ").concat(CONFIG.paddingHorizontal)
  },
  cardHeader: {
    backgroundColor: CONFIG.headerFooter.background,
    borderBottom: CONFIG.border,
    padding: "".concat(CONFIG.paddingVertical, " ").concat(CONFIG.paddingHorizontal)
  },
  cardFooter: {
    backgroundColor: CONFIG.headerFooter.background,
    borderTop: CONFIG.border,
    padding: "".concat(CONFIG.paddingVertical, " ").concat(CONFIG.paddingHorizontal)
  },
  cardImage: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  fullBleed: {
    padding: 0
  }
});
var sectionStyles = {
  block: styles.cardBlock,
  header: styles.cardHeader,
  footer: styles.cardFooter,
  image: styles.cardImage
};
function getDarkThemeStyle(type) {
  var isHeaderFooter = type === CARD_SECTION_TYPE.HEADER || type === CARD_SECTION_TYPE.FOOTER;
  var backgroundStyle = isHeaderFooter ? {
    backgroundColor: CONFIG.headerFooter.backgroundThemeDark
  } : {};
  return StyleSheet.create({
    darkTheme: _objectSpread({
      borderColor: color.dividerThemeDark,
      color: color.primaryTextThemeDark
    }, backgroundStyle)
  });
}
function CardSection(_ref) {
  var children = _ref.children,
    htmlAttributes = _ref.htmlAttributes,
    isFullBleed = _ref.isFullBleed,
    isThemeDark = _ref.isThemeDark,
    rootClassName = _ref.rootClassName,
    style = _ref.style,
    type = _ref.type;
  return /*#__PURE__*/React.createElement("div", _extends({
    style: style
  }, css(rootClassName, sectionStyles[type], isFullBleed && styles.fullBleed, isThemeDark && getDarkThemeStyle(type).darkTheme), htmlAttributes), children);
}
CardSection.defaultProps = {
  type: CARD_SECTION_TYPE.BLOCK
};
export default compose(setDisplayName('CardSectionHOC'), getContext({
  isThemeDark: PropTypes.bool
}))(CardSection);